import {Navigate, Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {EmailRegistration} from './components/EmailRegistration'
import {EmailPasswordReset} from './components/EmailPasswordReset'


const AuthPage = () => {

  return <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='reg' element={ <EmailRegistration /> } />
      <Route path='forgot-password' element={ <EmailPasswordReset /> } />
      <Route index element={<Login />} />
      <Route path='/*' element={<Navigate to='login' />} />
    </Route>
  </Routes>
}

export { AuthPage }
